function TabsChanges() {
  const tabList = document.querySelectorAll('[data-tab]');
  const contentsList = document.querySelectorAll('[data-tab-contents]');
  if (!tabList || !contentsList) return

  tabList.forEach(clickedTab => {
    clickedTab.addEventListener('click', () => {
      //クリックされたタブから親をたどってグループIDを取得
      const parentElement = clickedTab.closest('[data-tab-group]');
      if (!parentElement) return;
      //クリックしたtabの親のdataset（data-tab-group）取得
      const tabGroup = parentElement.dataset.tabGroup;
      //クリックしたtabのdataset（data-tab）取得
      const tabId = clickedTab.dataset.tab;

      //同じ（data-tab-group）に対して処理
        //同じdata-tab-groupの.owd-tablist\\:itemを全て取得
      const tabsInGroup = document.querySelectorAll(`.owd-tablist[data-tab-group="${tabGroup}"] .owd-tablist-item`);
        //同じdata-tab-groupの.owd-tubcontents\\:itemを全て取得
      const contentsInGroup = document.querySelectorAll(`.owd-tubcontents[data-tab-group="${tabGroup}"] .owd-tubcontents-item`);
      tabsInGroup.forEach(tab => {
        //owd-tablist:itemの全activeとり
        tab.classList.remove("is-active");
      });
      //クリックしたタブにactiveをadd
      clickedTab.classList.add('is-active');

      contentsInGroup.forEach(contents => {
        //owd-tubcontents:itemの全activeとり
        contents.classList.remove("is-active");
        if (tabId === "all") {
          // クリックされたタブの data-tab が "all" の場合、すべてのコンテンツアイテムをアクティブにする
          contents.classList.add("is-active");
        } else {
          // それ以外の場合、tabId に一致するコンテンツアイテムのみをアクティブにする
          const targetContents = contents.dataset.tabContents;
          if (tabId === targetContents) {
            contents.classList.add("is-active");
          }
        }
      });
    });
  });
}

export {TabsChanges}
